'use client';

import { msJsClient } from '@/apiClients';
import { CookiesKeys } from '@/constants';
import type { UIComponentProps } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';
import Cookies from 'js-cookie';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export type AppPageProps = UIComponentProps & {};

export const AppPage = ({ children, className }: AppPageProps) => {
  const pathname = usePathname();
  const [isApprovedForBuying, setIsApprovedForBuying] = useState<boolean | undefined>(false);
  const [isPgcorpAccountCreated, setIsPgcorpAccountCreated] = useState<boolean | undefined>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getBusiness = async () => {
    try {
      const userRaw = Cookies.get('user');
      if (!userRaw) {
        setIsApprovedForBuying(false);
        setIsLoading(false);
        return;
      }
      const theUser = await JSON.parse(userRaw);
      if (!theUser.buyer_business) {
        setIsApprovedForBuying(false);
        setIsLoading(false);
        return;
      }
      const userBusinessDataRaw = Cookies.get(CookiesKeys.userBusinessData);
      let userBusinessData;
      if (!userBusinessDataRaw) {
        const userBusiness = await msJsClient.buyer.getBuyerBusinessByBusinessId(theUser.buyer_business.id);
        if (userBusiness.data) {
          userBusinessData = userBusiness.data;
          Cookies.set(CookiesKeys.userBusinessData, JSON.stringify(userBusinessData));
        }
      } else {
        userBusinessData = JSON.parse(userBusinessDataRaw);
      }
      setIsPgcorpAccountCreated(!!userBusinessData?.pgCorpApiToken);
      setIsApprovedForBuying(userBusinessData?.isApprovedForBuying);
      setIsLoading(false);
    } catch (e) {
      console.error(`could not fetch user business for user ${e}`);
      return;
    }
  };

  useEffect(() => {
    getBusiness();
  }, []);

  // if is dashboard route, we only have a pathArray of length 2 since only one slash
  const pathArray = pathname.split('/');
  // allowed to see /wolfe and /wolfe/products only
  const isDashboardOrProducts = pathArray.length === 2 || (pathArray.length === 3 && pathArray[2] === 'products');

  return (
    <>
      {!isPgcorpAccountCreated ? (
        <div className={cn('container flex flex-col gap-4 @container', className)}>
          {!isLoading && (
            <div className="border-red-500 text-red-700 border-l-4 bg-primary-100 p-4" role="alert">
              <p className="font-bold">Note</p>
              <p>
                Your business account is under review. Once approved, you will be able to access the site. Please
                contact customer support for any questions.
              </p>
            </div>
          )}
        </div>
      ) : isApprovedForBuying || (!isApprovedForBuying && isDashboardOrProducts) ? (
        <div className={cn('container flex flex-col gap-4 @container', className)}>{children}</div>
      ) : (
        <div className={cn('container flex flex-col gap-4 @container', className)}>
          {!isLoading && (
            <div className="border-red-500 text-red-700 border-l-4 bg-primary-100 p-4" role="alert">
              <p className="font-bold">Note</p>
              <p>Your business has not been enabled for buying. Please contact customer support</p>
            </div>
          )}
        </div>
      )}
    </>
  );
};
